<template>
  <div class="pd-10">
    <h3 class="bg-app-green c-app-navy display-inline-block pd-l-20 pd-r-20 pd-t-5 pd-b-5 bdr-30">课程观看说明</h3>
    <p>1、为防止盗版，观看课程需要下载专属的加密视频播放器</p>
    <p>2、一个人仅能绑定一台设备，这个设备可以是电脑、可以是手机，但只能绑定一台，一旦绑定后，无法更换设备，建议使用电脑绑定，学习效果更佳</p>
    <p>3、下载播放器后输入下方账号密码即可观看课程</p>
    <h3 class="bg-app-green c-app-navy display-inline-block pd-l-20 pd-r-20 pd-t-5 pd-b-5 bdr-30">第一步:下载安装播放器</h3>
    <p>下载地址：<a class="c-app-navy" @click="copy('https://www.yuque.com/ankichina/lm007v/lft818','下载地址已复制')">https://www.yuque.com/ankichina/lm007v/lft818</a>
    </p>
    <p class="fs-14">（复制连接后，在浏览器打开）</p>
    <h3 class="bg-app-green c-app-navy display-inline-block pd-l-20 pd-r-20 pd-t-5 pd-b-5 bdr-30">第二步:输入账号密码登录</h3>
    <p>打开播放器，点击添加授权账号，输入你的账号和密码</p>
    <p>账号：<span>{{username}}</span><span @click="copy(username)" class="c-app-navy mg-l-50">复制</span></p>
    <p>密码：<span>{{password}}</span><span @click="copy(password)" class="c-app-navy mg-l-50">复制</span></p>
    <div class="position-fixed" id="copy-content" style="bottom: -999px;opacity: 0">{{copyContent}}</div>
  </div>
</template>

<script>
  import request from '../../libs/api.request'

  export default {
    name: "course-order",
    data() {
      return {
        username: '',
        password: '',
        copyContent: ''
      }
    },
    methods: {
      copy(text, message) {
        if (!message) {
          message = '已复制';
        }
        this.copyContent = text;
        setTimeout(() => {
          const range = document.createRange();
          range.selectNode(document.getElementById('copy-content'));
          const selection = window.getSelection();
          if (selection.rangeCount > 0) selection.removeAllRanges();
          selection.addRange(range);
          document.execCommand('copy');
          this.$toast(message)
        }, 200)
      },

    },
    mounted() {

      request.request({
        url: 'course/getPlayerInfo',
        params: this.$route.query
      }).then(data => {
        this.username = data.username;
        this.password = data.password;
      }).catch(e => {
        this.$toast(e.message)
      })
    }
  }
</script>

<style scoped>

</style>
